module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/9200459659/target03-22c322a353b89fbc03e3cc8cdee70335.png";